import React, { useState, ReactElement, useEffect, Fragment, CSSProperties, useMemo, useRef } from "react";

import { FONT } from "../../../value/staticValues";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE, TABLE_QUERY_MENU_TYPE } from "../../../value/type";
import { 
    StyleSheet, View, Text
} from "react-native";
import { ListButton, ListControlFilter, ListQueryMenu, ListQueryPeriod } from "./listTableType";

import { ReactComponent as ControlButtonCollapsedImg } from "../../../img/ico-prefix-line-collapsed.svg";
import { ReactComponent as ControlButtonExpandedImg } from "../../../img/ico-prefix-line-expanded.svg";
import { ReactComponent as SearchClearButtonImg } from "../../../img/ico-prefix-search-clear.svg";
import { ReactComponent as SearchExecutionButtonImg } from "../../../img/ico-prefix-search.svg";

import { getCurrentTimestamp } from "../../../common/util";

// import RoundCalendar from "../roundCalendar";
// import ConfirmRectangleButton from "../confirmRectangleButton";
// import NormalRectangleButton from "../normalRectangleButton";

import { useTranslation } from "react-i18next";


interface QueryMenuControlFilterButtonItemProps {
    name: string;
    code: string;
    type: string;
    clickCb: Function;
    lastYn: boolean;
    firstYn: boolean;
    activeYn?: boolean;
    selectYn?: boolean;
    detectClickEventCb: Function;
}

function QueryMenuControlFilterButtonItem(props:QueryMenuControlFilterButtonItemProps) {
    const firstBorderRadiusStyle = "10px 10px 0px 0px";
    const lastBorderRadiusStyle = "0px 0px 10px 10px";
    const firstAndLastBorderRadiusStyle = "10px";
    const middleBorderRadiusStyle = "0px";
    const [activeYn, setActiveYn] = useState(props.activeYn);
    const [queryMenuControlFilterButtonItemStyle, setQueryMenuControlFilterButtonItemStyle] = useState({...className.queryMenuControlFilterButtonItem, borderRadius: props.firstYn? props.lastYn? firstAndLastBorderRadiusStyle:firstBorderRadiusStyle : props.lastYn ? lastBorderRadiusStyle: middleBorderRadiusStyle});
    const [mouseHoverYn, setMouseHover] = useState(false);

    useEffect(() => {
        if(activeYn !== props.activeYn) {
            
            setActiveYn(props.activeYn);
        }
    }, [props.activeYn]);


    useEffect(() => {
        if(activeYn === false) {
            //disable
            setQueryMenuControlFilterButtonItemStyle({...className.queryMenuControlFilterButtonItemDisabled, borderRadius: props.firstYn? props.lastYn? firstAndLastBorderRadiusStyle:firstBorderRadiusStyle : props.lastYn ? lastBorderRadiusStyle: middleBorderRadiusStyle});
        } else {
            if(mouseHoverYn) {
                // hover
                setQueryMenuControlFilterButtonItemStyle({...className.queryMenuControlFilterButtonItemHover, borderRadius: props.firstYn? props.lastYn? firstAndLastBorderRadiusStyle:firstBorderRadiusStyle : props.lastYn ? lastBorderRadiusStyle: middleBorderRadiusStyle});
            } else {
                // normal
                setQueryMenuControlFilterButtonItemStyle({...className.queryMenuControlFilterButtonItem, borderRadius: props.firstYn? props.lastYn? firstAndLastBorderRadiusStyle:firstBorderRadiusStyle : props.lastYn ? lastBorderRadiusStyle: middleBorderRadiusStyle});
            }
        }
        
    }, [mouseHoverYn, activeYn]);


    const divRef = useRef(null);
    useEffect(() => {
        window.addEventListener("click", detectClickEvent);
        return () => {
            window.removeEventListener("click", detectClickEvent);
        };
    },[]);
    
    function detectClickEvent(event:MouseEvent) {
        props.detectClickEventCb(event, divRef);
    }

    function setMouseOver(hoverYn:boolean) {
        setMouseHover(hoverYn);
    }

    
    function clickItem() {
        if(activeYn !== false) {
            props.clickCb(props.type, props.code);
        }
    }

    return (
        <Fragment>
            <div style={queryMenuControlFilterButtonItemStyle} ref={divRef}
                onMouseOut={() => { setMouseOver(false); }}
                onMouseOver={() => { setMouseOver(true); }}
                onClick={(e) => { clickItem(); }}
            >
                {props.name}
            </div>
            {
                props.lastYn ? null : <div style={className.queryMenuControlFilterButtonItemDivContainer}></div>
            }
    </Fragment>
    )
}


interface QueryMenuControlFilterButtonProps {
    id: number;
    name: string;
    activeYn: boolean;
    items: ListControlFilter[];
    clickCb: Function;
}

function QueryMenuControlFilterButton(props:QueryMenuControlFilterButtonProps) {
    const [activeYn, setActiveYn] = useState(props.activeYn);
    const [queryMenuControlFilterButtonStyle, setQueryMenuControlFilterButtonStyle] = useState(className.queryMenuControlFilterButton);
    const [queryMenuControlFilterButtonArrowStyle, setQueryMenuControlFilterButtonArrowStyle] = useState(className.queryMenuControlFilterButtonExpandedImg);
    const [mouseHoverYn, setMouseHover] = useState(false);
    const [expandedYn, setExpandedYn] = useState(false);

    useEffect(() => {
        if(activeYn !== props.activeYn) {
            setActiveYn(props.activeYn);
        }
    }, [props]);

    useEffect(() => {
        if(!activeYn) {
            //disable
            setQueryMenuControlFilterButtonStyle(className.queryMenuControlFilterButtonDisabled);
            setQueryMenuControlFilterButtonArrowStyle({...className.queryMenuControlFilterButtonExpandedImg, filter: "opacity(0.5) grayscale(0.5)"});
            if(expandedYn) {
                setExpandedYn(false);
            }
        } else {
            setQueryMenuControlFilterButtonArrowStyle(className.queryMenuControlFilterButtonExpandedImg);
            if(mouseHoverYn) {
                // hover
                setQueryMenuControlFilterButtonStyle(className.queryMenuControlFilterButtonHover);
            } else {
                // normal
                setQueryMenuControlFilterButtonStyle(className.queryMenuControlFilterButton);
            }
        }
    }, [mouseHoverYn, activeYn]);


    function setMouseOver(hoverYn:boolean) {
        if(activeYn) {
            setMouseHover(hoverYn);
        }
    }

    
    function clickButton() {
        if(activeYn) {
            setExpandedYn(!expandedYn);    
        }
    }

    function clickSelectItem(type:string, code:string) {
        props.clickCb(type, code);
        for(let item of props.items) {
            if(item.code === code) {
                item.selectYn = true;
            } else {
                item.selectYn = false;
            }

        }
        setExpandedYn(false);
    }

    function detectClickEvent(event:MouseEvent, element:any) {
        if(!element.current || !element.current.contains(event.target)) {
            if(expandedYn) {
                setExpandedYn(false);
            }
        }
    }
    return (
        <View style={style.queryMenuControlFilterButtonContainer}>
            <div style={queryMenuControlFilterButtonStyle}
                onMouseOut={() => { setMouseOver(false); }}
                onMouseOver={() => { setMouseOver(true); }}
                onClick={(e) => { clickButton(); }}
            >
                {
                    props.items.map((item:ListControlFilter, index) => {
                        if(item.selectYn === true) {
                            return item.name;
                        } else {
                            return false;
                        }
                    }).filter((v)=>{if(v !== false) return v})
                }
                {
                    expandedYn ? 
                    <ControlButtonExpandedImg style={queryMenuControlFilterButtonArrowStyle}/>:
                    <ControlButtonCollapsedImg style={queryMenuControlFilterButtonArrowStyle}/>
                }
            </div>
            {
                expandedYn ?
                <div style={className.queryMenuControlFilterButtonItemListContainer}>
                    {
                        props.items.map((item:ListControlFilter, index) => {
                            if(index === 0) {
                                if(index === props.items.length - 1) {
                                    return (<QueryMenuControlFilterButtonItem key={index} name={item.name} code={item.code} type={item.type} selectYn={item.selectYn} activeYn={item.activeYn} clickCb={clickSelectItem} firstYn={true} lastYn={true} detectClickEventCb={detectClickEvent}/>)
                                } else {
                                    return (<QueryMenuControlFilterButtonItem key={index} name={item.name} code={item.code} type={item.type} selectYn={item.selectYn} activeYn={item.activeYn} clickCb={clickSelectItem} firstYn={true} lastYn={false} detectClickEventCb={detectClickEvent}/>)
                                }
                            } else {
                                if(index === props.items.length - 1) {
                                    return (<QueryMenuControlFilterButtonItem key={index} name={item.name} code={item.code} type={item.type} selectYn={item.selectYn} activeYn={item.activeYn} clickCb={clickSelectItem} firstYn={false} lastYn={true} detectClickEventCb={detectClickEvent}/>)
                                } else {
                                    return (<QueryMenuControlFilterButtonItem key={index} name={item.name} code={item.code} type={item.type} selectYn={item.selectYn} activeYn={item.activeYn} clickCb={clickSelectItem} firstYn={false} lastYn={false} detectClickEventCb={detectClickEvent}/>)
                                }
                            }
                            
                        })
                    }
                </div>
                :null
                
            }
        </View>
    );

}


interface QueryMenuControlPeriodButtonItemProps {
    name: string;
    code: string;
    type: string;
    clickCb: Function;
    lastYn: boolean;
    firstYn: boolean;
    activeYn?: boolean;
    selectYn?: boolean;
    detectClickEventCb: Function;
}

function QueryMenuControlPeriodButtonItem(props:QueryMenuControlPeriodButtonItemProps) {
    const firstBorderRadiusStyle = "10px 10px 0px 0px";
    const lastBorderRadiusStyle = "0px 0px 10px 10px";
    const firstAndLastBorderRadiusStyle = "10px";
    const middleBorderRadiusStyle = "0px";
    const [activeYn, setActiveYn] = useState(props.activeYn);
    const [queryMenuControlPeriodButtonItemStyle, setQueryMenuControlPeriodButtonItemStyle] = useState({...className.queryMenuControlPeriodButtonItem, borderRadius: props.firstYn? props.lastYn? firstAndLastBorderRadiusStyle:firstBorderRadiusStyle : props.lastYn ? lastBorderRadiusStyle: middleBorderRadiusStyle});
    const [mouseHoverYn, setMouseHover] = useState(false);

    useEffect(() => {
        if(activeYn !== props.activeYn) {
            
            setActiveYn(props.activeYn);
        }
    }, [props.activeYn]);


    useEffect(() => {
        if(activeYn === false) {
            //disable
            setQueryMenuControlPeriodButtonItemStyle({...className.queryMenuControlPeriodButtonItemDisabled, borderRadius: props.firstYn? props.lastYn? firstAndLastBorderRadiusStyle:firstBorderRadiusStyle : props.lastYn ? lastBorderRadiusStyle: middleBorderRadiusStyle});
        } else {
            if(mouseHoverYn) {
                // hover
                setQueryMenuControlPeriodButtonItemStyle({...className.queryMenuControlPeriodButtonItemHover, borderRadius: props.firstYn? props.lastYn? firstAndLastBorderRadiusStyle:firstBorderRadiusStyle : props.lastYn ? lastBorderRadiusStyle: middleBorderRadiusStyle});
            } else {
                // normal
                setQueryMenuControlPeriodButtonItemStyle({...className.queryMenuControlPeriodButtonItem, borderRadius: props.firstYn? props.lastYn? firstAndLastBorderRadiusStyle:firstBorderRadiusStyle : props.lastYn ? lastBorderRadiusStyle: middleBorderRadiusStyle});
            }
        }
        
    }, [mouseHoverYn, activeYn]);


    const divRef = useRef(null);
    useEffect(() => {
        window.addEventListener("click", detectClickEvent);
        return () => {
            window.removeEventListener("click", detectClickEvent);
        };
    },[]);
    
    function detectClickEvent(event:MouseEvent) {
        props.detectClickEventCb(event, divRef);
    }

    function setMouseOver(hoverYn:boolean) {
        setMouseHover(hoverYn);
    }

    
    function clickItem() {
        if(activeYn !== false) {
            props.clickCb(props.type, props.code);
        }
    }

    return (
        <Fragment>
            <div style={queryMenuControlPeriodButtonItemStyle} ref={divRef}
                onMouseOut={() => { setMouseOver(false); }}
                onMouseOver={() => { setMouseOver(true); }}
                onClick={(e) => { clickItem(); }}
            >
                {props.name}
            </div>
            {
                props.lastYn ? null : <div style={className.queryMenuControlPeriodButtonItemDivContainer}></div>
            }
    </Fragment>
    )
}


interface QueryMenuControlPeriodButtonProps {
    id: number;
    name: string;
    activeYn: boolean;
    items: ListControlFilter[];
    clickCb: Function;
}

function QueryMenuControlPeriodButton(props:QueryMenuControlPeriodButtonProps) {
    const [activeYn, setActiveYn] = useState(props.activeYn);
    const [queryMenuControlPeriodButtonStyle, setQueryMenuControlPeriodButtonStyle] = useState(className.queryMenuControlPeriodButton);
    const [queryMenuControlPeriodButtonArrowStyle, setQueryMenuControlPeriodButtonArrowStyle] = useState(className.queryMenuControlPeriodButtonExpandedImg);
    const [mouseHoverYn, setMouseHover] = useState(false);
    const [expandedYn, setExpandedYn] = useState(false);

    useEffect(() => {
        if(activeYn !== props.activeYn) {
            setActiveYn(props.activeYn);
        }
    }, [props]);

    useEffect(() => {
        if(!activeYn) {
            //disable
            setQueryMenuControlPeriodButtonStyle(className.queryMenuControlPeriodButtonDisabled);
            setQueryMenuControlPeriodButtonArrowStyle({...className.queryMenuControlPeriodButtonExpandedImg, filter: "opacity(0.5) grayscale(0.5)"});
            if(expandedYn) {
                setExpandedYn(false);
            }
        } else {
            setQueryMenuControlPeriodButtonArrowStyle(className.queryMenuControlPeriodButtonExpandedImg);
            if(mouseHoverYn) {
                // hover
                setQueryMenuControlPeriodButtonStyle(className.queryMenuControlPeriodButtonHover);
            } else {
                // normal
                setQueryMenuControlPeriodButtonStyle(className.queryMenuControlPeriodButton);
            }
        }
    }, [mouseHoverYn, activeYn]);


    function setMouseOver(hoverYn:boolean) {
        if(activeYn) {
            setMouseHover(hoverYn);
        }
    }

    
    function clickButton() {
        if(activeYn) {
            setExpandedYn(!expandedYn);    
        }
    }

    function clickSelectItem(type:string, code:string) {
        props.clickCb(type, code);
        for(let item of props.items) {
            if(item.code === code) {
                item.selectYn = true;
            } else {
                item.selectYn = false;
            }

        }
        setExpandedYn(false);
    }

    function detectClickEvent(event:MouseEvent, element:any) {
        if(!element.current || !element.current.contains(event.target)) {
            if(expandedYn) {
                setExpandedYn(false);
            }
        }
    }
    return (
        <View style={style.queryMenuControlPeriodButtonContainer}>
            <div style={queryMenuControlPeriodButtonStyle}
                onMouseOut={() => { setMouseOver(false); }}
                onMouseOver={() => { setMouseOver(true); }}
                onClick={(e) => { clickButton(); }}
            >
                {
                    props.items.map((item:ListControlFilter, index) => {
                        if(item.selectYn === true) {
                            return item.name;
                        } else {
                            return false;
                        }
                    }).filter((v)=>{if(v !== false) return v})
                }
                {
                    expandedYn ? 
                    <ControlButtonExpandedImg style={queryMenuControlPeriodButtonArrowStyle}/>:
                    <ControlButtonCollapsedImg style={queryMenuControlPeriodButtonArrowStyle}/>
                }
            </div>
            {
                expandedYn ?
                <div style={className.queryMenuControlPeriodButtonItemListContainer}>
                    {
                        props.items.map((item:ListControlFilter, index) => {
                            if(index === 0) {
                                if(index === props.items.length - 1) {
                                    return (<QueryMenuControlPeriodButtonItem key={index} name={item.name} code={item.code} type={item.type} selectYn={item.selectYn} activeYn={item.activeYn} clickCb={clickSelectItem} firstYn={true} lastYn={true} detectClickEventCb={detectClickEvent}/>)
                                } else {
                                    return (<QueryMenuControlPeriodButtonItem key={index} name={item.name} code={item.code} type={item.type} selectYn={item.selectYn} activeYn={item.activeYn} clickCb={clickSelectItem} firstYn={true} lastYn={false} detectClickEventCb={detectClickEvent}/>)
                                }
                            } else {
                                if(index === props.items.length - 1) {
                                    return (<QueryMenuControlPeriodButtonItem key={index} name={item.name} code={item.code} type={item.type} selectYn={item.selectYn} activeYn={item.activeYn} clickCb={clickSelectItem} firstYn={false} lastYn={true} detectClickEventCb={detectClickEvent}/>)
                                } else {
                                    return (<QueryMenuControlPeriodButtonItem key={index} name={item.name} code={item.code} type={item.type} selectYn={item.selectYn} activeYn={item.activeYn} clickCb={clickSelectItem} firstYn={false} lastYn={false} detectClickEventCb={detectClickEvent}/>)
                                }
                            }
                            
                        })
                    }
                </div>
                :null
                
            }
        </View>
    );

}

interface QueryMenuButtonItemProps {
    id: number;
    name: string;
    activeYn: boolean;
    item?: ListButton;
    clickCb: Function
}

function QueryMenuButtonItem(props:QueryMenuButtonItemProps) {
    const [activeYn, setActiveYn] = useState(props.activeYn);
    const [type, setType] = useState("");
    const [queryMenuButtonItemStyle, setQueryMenuButtonItemStyle] = useState({});
    const [mouseHoverYn, setMouseHover] = useState(false);
    const [normalStyle, setNormalStyle] = useState({});
    const [disabledStyle, setDisabledStyle] = useState({});
    const [hoverStyle, setHoverStyle] = useState({});
    

    useEffect(() => {
        if(!props.item) {
            return ;
        }
        
        if(props.item.type !== type) {
            if(props.item.type === TABLE_BUTTON_TYPE.PUSH) {
                setNormalStyle(className.queryMenuButtonItemPush);
                setDisabledStyle(className.queryMenuButtonItemPushDisabled);
                setHoverStyle(className.queryMenuButtonItemPushHover);
            } else if(props.item.type === TABLE_BUTTON_TYPE.PUSH_WITH_ICON) {
                setNormalStyle(className.queryMenuButtonItemPushWithIcon);
                setDisabledStyle(className.queryMenuButtonItemPushWithIconDisabled);
                setHoverStyle(className.queryMenuButtonItemPushWithIconHover);
            } else if(props.item.type === TABLE_BUTTON_TYPE.DELETE) {
                setNormalStyle(className.queryMenuButtonItemDelete);
                setDisabledStyle(className.queryMenuButtonItemDeleteDisabled);
                setHoverStyle(className.queryMenuButtonItemDeleteHover);
            } else if(props.item.type === TABLE_BUTTON_TYPE.CANCEL) {
                setNormalStyle(className.queryMenuButtonItemCancel);
                setDisabledStyle(className.queryMenuButtonItemCancelDisabled);
                setHoverStyle(className.queryMenuButtonItemCancelHover);
            } else if(props.item.type === TABLE_BUTTON_TYPE.DARK_PUSH) {
                setNormalStyle(className.queryMenuButtonItemDarkPush);
                setDisabledStyle(className.queryMenuButtonItemDarkPushDisabled);
                setHoverStyle(className.queryMenuButtonItemDarkPushHover);
            } else {
                return ;
            }
            setType(props.item.type);
        }
        if(!activeYn) {
            setQueryMenuButtonItemStyle(disabledStyle);
        } else {
            setQueryMenuButtonItemStyle(normalStyle);
        }
        
        if(activeYn !== props.activeYn) {
            setActiveYn(props.activeYn);
        }
    }, [props]);


    useEffect(() => {
        
        if(!activeYn) {
            //disable
            setQueryMenuButtonItemStyle(disabledStyle);
        } else {
            if(mouseHoverYn) {
                // hover
                setQueryMenuButtonItemStyle(hoverStyle);
            } else {
                // normal
                setQueryMenuButtonItemStyle(normalStyle);
            }
        }
    }, [mouseHoverYn, activeYn]);



    function setMouseOver(hoverYn:boolean) {
        if(activeYn) {
            setMouseHover(hoverYn);
        }
    }

    function clickItem(event:React.MouseEvent) {
        if(activeYn) {
            props.clickCb(props.item?props.item.code : "");
        }
    }

    

    return (
        <View style={style.queryMenuButtonItemContainer}>
            <div style={queryMenuButtonItemStyle}
                onMouseOut={() => { setMouseOver(false); }}
                onMouseOver={() => { setMouseOver(true); }}
                onClick={(e) => { clickItem(e); }}
                >
                {
                    (() => {
                        if(!props.item) return null;
                        if(!activeYn) {
                            return props.item.inactiveImgComponent ? <div style={className.queryMenuButtonItemImgContainer}> {props.item.inactiveImgComponent} </div>: null;
                        }
                        if(mouseHoverYn) {
                            return props.item.activeImgComponent ? <div style={className.queryMenuButtonItemImgContainer}> {props.item.activeImgComponent} </div>: null;
                        } 
                        return props.item.imgComponent ? <div style={className.queryMenuButtonItemImgContainer}> {props.item.imgComponent} </div> : null;
                    })()
                }
                {props.name}
            </div>
        </View>
    );
}


interface QeuryMenuPeriodSearchProps {
    period: ListQueryPeriod;
    periodClickCb: Function;
    searchClickCb: Function;
    presetYn?: boolean;
    activeYn: boolean;
};
export function QeuryMenuPeriodSearch(props:QeuryMenuPeriodSearchProps) {
    const { t } = useTranslation();

    function selectDate(id:string, ts:number) {
        if(id === "queryStartTs") {
            props.periodClickCb(ts, props.period.endTs);
        } else if(id === "queryEndTs") {
            props.periodClickCb(props.period.startTs, ts);
        }
    }

    function clickQueryTableButton() {
        props.searchClickCb();
    }

    function clickRangeButton(type:string) {
        if(type === "TODAY") {
            props.periodClickCb(getCurrentTimestamp(), getCurrentTimestamp());
        } else if(type === "WEEK") {
            props.periodClickCb(getCurrentTimestamp() - 518400, getCurrentTimestamp());
        } else if(type === "MONTH") {
            props.periodClickCb(getCurrentTimestamp() - 2592000, getCurrentTimestamp());
        } else if(type === "YEAR") {
            props.periodClickCb(getCurrentTimestamp() - 31449600, getCurrentTimestamp());
        }

    }
    return (
        <View style={style.queryMenuPeriodSearchContainer}>
            {/* {
                props.presetYn === true ?
                <Fragment>
                    <View style={style.queryConditionContainer}>
                        <NormalRectangleButton label={t("TODAY_TEXT")} clickButtonCb={() => {clickRangeButton("TODAY")}} activeYn={true} width={33} height={9} />
                    </View>
                    <View style={style.queryConditionContainer}>
                        <NormalRectangleButton label={"1" + t("WEEK_RANGE_TEXT")} clickButtonCb={() => {clickRangeButton("WEEK")}} activeYn={true} width={33} height={9} />
                    </View>
                    <View style={style.queryConditionContainer}>
                        <NormalRectangleButton label={"1" + t("MONTH_RANGE_TEXT")} clickButtonCb={() => {clickRangeButton("MONTH")}} activeYn={true} width={33} height={9} />
                    </View>
                    <View style={style.queryConditionContainer}>
                        <NormalRectangleButton label={"1" + t("YEAR_TEXT")} clickButtonCb={() => {clickRangeButton("YEAR")}} activeYn={true} width={33} height={9} />
                    </View>
                </Fragment>
                : null
            }
            <View style={style.calendarInputContainer}>
                <RoundCalendar id={"queryStartTs"} dateTs={props.period.startTs} maxTs={getCurrentTimestamp()} selectDateCb={selectDate} activeYn={props.activeYn}/>
            </View>
            <View style={style.caledarInputDivContainer}>
                <Text style={style.caledarInputDivText}>{" ~ "}</Text>
            </View>
            <View style={style.calendarInputContainer}>
                <RoundCalendar id={"queryEndTs"} dateTs={props.period.endTs} maxTs={getCurrentTimestamp()} selectDateCb={selectDate} activeYn={props.activeYn}/>
            </View>
            <View style={style.calendarInputContainer}>
                <ConfirmRectangleButton label={t("QUERY_TEXT")} clickButtonCb={clickQueryTableButton} activeYn={true} width={33} height={9} />
            </View> */}
        </View>
    )
}


interface QueryMenuProps {
    menus: ListQueryMenu[];
    filterClickCb: Function;
    periodClickCb: Function;
    buttonClickCb: Function;
    searchCb: Function;
    searchValue: string;
    searchBarYn: boolean;
};


function QueryMenu(props: QueryMenuProps) {
    const [menus, setMenus] = useState<ListQueryMenu[]>([]);
    const [queryPeriod, setQueryPeriod] = useState<ListQueryPeriod>({type:"", startTs: getCurrentTimestamp() - 31536000, endTs: getCurrentTimestamp()});
    

    useEffect(() => {
        setMenus(props.menus);
    }, [props.menus]);

    function clickQueryFilter(type:string, code:string) {
        props.filterClickCb(type, code);
    }
    function clickMenuButtonItem(code:string) {
        props.buttonClickCb(code);
    }
    function clickQueryPeriod(type:string, code:string) {
        setQueryPeriod({type:code, startTs:queryPeriod.startTs, endTs:queryPeriod.endTs});
    }
    function clickMenuPeriodRange(startTs:number, endTs:number) {
        setQueryPeriod({type:queryPeriod.type, startTs: startTs, endTs:endTs});
    }
    function clickMenuPeriodSearch() {
        props.periodClickCb(queryPeriod.type, queryPeriod.startTs, queryPeriod.endTs);
    }
    function executeSearch(value:string) {
        props.searchCb(value);
    }

    return (
        <View style={style.queryMenuContainer}>
            <div style={{...className.queryTopContainer, zIndex:10}}>
            {
                menus.map((menu:ListQueryMenu, index) => {
                    if(menu.type === TABLE_QUERY_MENU_TYPE.CONTROL_FILTER_BUTTON && menu.topYn) {
                        return <QueryMenuControlFilterButton
                            key={index}
                            id={menu.id}
                            name={menu.name}
                            activeYn={menu.activeYn}
                            items={menu.controlFilter ? menu.controlFilter: []}
                            clickCb={clickQueryFilter}
                            />;
                    } else if(menu.type === TABLE_QUERY_MENU_TYPE.PUSH_BUTTON && menu.topYn) {
                        return <QueryMenuButtonItem
                                key={index}
                                id={menu.id}
                                name={menu.name}
                                activeYn={menu.activeYn}
                                item={menu.button}
                                clickCb={clickMenuButtonItem}
                            />;
                    } else if(menu.type === TABLE_QUERY_MENU_TYPE.CONTROL_PERIOD_BUTTON && menu.topYn) {
                        return <QueryMenuControlPeriodButton
                            key={index}
                            id={menu.id}
                            name={menu.name}
                            activeYn={menu.activeYn}
                            items={menu.controlFilter ? menu.controlFilter: []}
                            clickCb={clickQueryPeriod}
                        />
                    } else {
                        return null;
                    }
                })
            }
            {
                (()=>{
                    let periodSearchYn = false;
                    let presetYn = false;
                    for(let button of menus) {
                        if(button.type === TABLE_QUERY_MENU_TYPE.CONTROL_PERIOD_BUTTON || button.type === TABLE_QUERY_MENU_TYPE.CONTROL_PERIOD_PRESET_BUTTON) {
                            periodSearchYn = true;
                        }
                        if(button.type === TABLE_QUERY_MENU_TYPE.CONTROL_PERIOD_PRESET_BUTTON) {
                            presetYn = true;
                        }
                    }
                    if(periodSearchYn) {
                        return <QeuryMenuPeriodSearch
                            period={queryPeriod}
                            periodClickCb={clickMenuPeriodRange}
                            searchClickCb={clickMenuPeriodSearch}
                            activeYn={queryPeriod.type || presetYn ? true : false}
                            presetYn={presetYn}
                            />
                    }
                })()
            }
            </div>
            <View style={style.queryMenuDivContainer}></View>
            <View style={style.queryBottomContainer}>
            {
                menus.map((menu:ListQueryMenu, index) => {
                    if(menu.type === TABLE_QUERY_MENU_TYPE.CONTROL_FILTER_BUTTON && !menu.topYn) {
                        return <QueryMenuControlFilterButton
                            key={index}
                            id={menu.id}
                            name={menu.name}
                            activeYn={menu.activeYn}
                            items={menu.controlFilter ? menu.controlFilter: []}
                            clickCb={clickQueryFilter}
                            />;
                    } else if(menu.type === TABLE_QUERY_MENU_TYPE.PUSH_BUTTON && !menu.topYn) {
                        return <QueryMenuButtonItem
                                key={index}
                                id={menu.id}
                                name={menu.name}
                                activeYn={menu.activeYn}
                                item={menu.button}
                                clickCb={clickMenuButtonItem}
                            />;
                    } else {
                        return null;
                    }
                })
            }
            {
                props.searchBarYn ? 
                <QueryMenuSearchBar searchValue={props.searchValue} executeCb={executeSearch}/>
                : null
            }
            </View>
        </View>
    )
}

interface QueryMenuSearchBarProps {
    searchValue: string;
    executeCb: Function;
}
function QueryMenuSearchBar(props:QueryMenuSearchBarProps) {
    const [searchValue, setSearchValue] = useState(props.searchValue);
    const [showSearchClearYn, setShowSearchClearYn] = useState(false);
    const [queryMenuSearchInputStyle, setQueryMenuSearchInputStyle] = useState(className.queryMenuSearchInput);
    const [queryMenuSearchInputClearButtonStyle, setQueryMenuSearchInputClearButtonStyle] = useState(className.queryMenuSearchInputClearButtonImg);
    const [queryMenuSearchInputExecutionButtonStyle, setQueryMenuSearchInputExecutionButtonStyle] = useState(className.queryMenuSearchInputExecutionButtonImg);


    useEffect(() => {
        setSearchValue(props.searchValue);
    }, [props]);

    function executeSearch() {
        props.executeCb(searchValue);
    }

    function valueClear() {
        setSearchValue('');
    }

    return (
        <View style={style.queryMenuSearchBarContainer}>
            <form onSubmit={(e) => { executeSearch(); e.preventDefault();} }>
                <input type="text"
                    style={queryMenuSearchInputStyle}
                    value={searchValue}
                    onChange={(e) => { setSearchValue(e.target.value); setShowSearchClearYn(e.target.value !== '') }}
                    onFocus={(e) => { setQueryMenuSearchInputStyle(className.queryMenuSearchInputActive); }}
                    onBlur={(e) => { setQueryMenuSearchInputStyle(className.queryMenuSearchInput); }}
                />
            </form>
                {
                    showSearchClearYn ?
                    <SearchClearButtonImg style={queryMenuSearchInputClearButtonStyle} onClick={()=> {valueClear()}}/> : null
                }
                <SearchExecutionButtonImg style={queryMenuSearchInputExecutionButtonStyle} onClick={()=> {executeSearch()}}/>
            
            
        </View>
    )
}

const style = StyleSheet.create({
    queryMenuContainer: {
        width: "inherit",
        height: 120,
        padding: 12,
        borderRadius: 20,
        backgroundColor: "#f0f3fa",
        zIndex: 1
        
    },
    queryMenuDivContainer: {
        width: "inherit",
        height: 1,
        backgroundColor: "#dfe2e6"
    },
    queryMenuSearchBarContainer: {
        marginLeft: "auto",
        marginRight: 12,
        flexDirection: "row",
        alignItems: "center"
    },
    queryConditionContainer: {
        marginRight: 5
    },
    queryBottomContainer: {
        width: "inherit",
        height: 47,
        flexDirection: "row",
        alignItems: "flex-end"
    },
    queryMenuButtonItemContainer: {
        height: 36,
    },
    queryMenuControlFilterButtonContainer: {
        height: 36,
        minWidth: 130,
    },
    queryMenuControlPeriodButtonContainer: {
        height: 36,
        minWidth: 100,
        marginLeft: "auto",
    },
    queryMenuPeriodSearchContainer: {
        flexDirection: "row",
        alignItems: "center",
        marginRight: 7,
    },
    queryMenuPeriodSearchRightContainer: {
        flexDirection: "row",
        alignItems: "center",
        marginRight: 7,
        marginLeft: "auto"
    },
    calendarInputContainer: {
        marginRight: 5,
    },
    caledarInputDivContainer: {

    },
    caledarInputDivText: {
        marginRight: 12,
        marginLeft: 7,
        fontFamily: FONT.REGULAR,
        fontSize: 14,
        color: "#9ea0a5"
    },
});

const className = {
    queryTopContainer: {
        width: "inherit",
        height: "48px",
        display: "flex",
        alignItems: "flex-start"
    },
    queryMenuSearchInput: {
        width: "400px",
        height: "20px",
        padding: "8px 10px 8px 15px",
        border: "solid 1px #e4e7eb",
        borderRadius: "10px",
        boxShadow: "0 0 0 1px rgba(99, 122, 255, 0)",
        outline: "none",
        fontFamily: FONT.REGULAR,
        fontSize: "13px",
        lineHeight: "-0.05px",
        backgroundColor: "#fff"
    },
    queryMenuSearchInputActive: {
        width: "400px",
        height: "20px",
        padding: "8px 10px 8px 15px",
        border: "solid 1px #e4e7eb",
        borderRadius: "10px",
        boxShadow: "0 0 0 1px rgba(99, 122, 255, 0.5)",
        outline: "none",
        fontFamily: FONT.REGULAR,
        fontSize: "13px",
        lineHeight: "-0.05px",
        backgroundColor: "#fff"
    },
    queryMenuSearchInputClearButtonImg: {
        position: "absolute",
        marginLeft: "365px",
        cursor: "pointer"
    } as CSSProperties,
    queryMenuSearchInputExecutionButtonImg: {
        position: "absolute",
        marginLeft: "390px",
        cursor: "pointer"
    } as CSSProperties,

    queryMenuButtonItemImgContainer: {
        marginRight: "5px",
    },
    queryMenuButtonItemPush: {
        height: "36px",
        marginRight: "5px",
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 1px #d4d9db",
        backgroundColor: "#fff",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#262626",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    queryMenuButtonItemPushHover: {
        height: "36px",
        marginRight: "5px",
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 1px #d4d9db",
        backgroundColor: "#fafafa",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#262626",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    queryMenuButtonItemPushDisabled: {
        height: "36px",
        marginRight: "5px",
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 1px #d4d9db",
        backgroundColor: "#f2f2f2",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#d9d9d9",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "not-allowed"
    },
    queryMenuButtonItemPushWithIcon: {
        height: "18px",
        marginRight: "5px",
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 1px rgba(60, 93, 242, 0.5)",
        boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.2)",
        backgroundColor: "#fff",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#3c5df2",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    queryMenuButtonItemPushWithIconHover: {
        height: "18px",
        marginRight: "5px",
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 1px rgba(60, 93, 242, 0.5)",
        boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.2)",
        backgroundColor: "#4f5fd8",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    queryMenuButtonItemPushWithIconDisabled: {
        height: "18px",
        marginRight: "5px",
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 1px #d4d9db",
        boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.2)",
        backgroundColor: "#f2f4f7",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#d9d9d9",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "not-allowed"
    },
    queryMenuButtonItemDelete: {
        height: "38px",
        marginRight: "5px",
        padding: "9px 15px",
        borderRadius: "10px",
        backgroundColor: "#9ea0a5",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    queryMenuButtonItemDeleteHover: {
        height: "38px",
        marginRight: "5px",
        padding: "9px 15px",
        borderRadius: "10px",
        backgroundColor: "#626366",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    queryMenuButtonItemDeleteDisabled: {
        height: "38px",
        marginRight: "5px",
        padding: "9px 15px",
        borderRadius: "10px",
        backgroundColor: "#dcdfe6",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "not-allowed"
    },
    queryMenuButtonItemCancel: {
        height: "36px",
        marginRight: "5px",
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 1px #d4d9db",
        backgroundColor: "#fff",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#a6a6a6",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    queryMenuButtonItemCancelHover: {
        height: "36px",
        marginRight: "5px",
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 1px #d4d9db",
        backgroundColor: "#fafafa",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#8c8c8c",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    queryMenuButtonItemCancelDisabled: {
        height: "36px",
        marginRight: "5px",
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 1px #d4d9db",
        backgroundColor: "#fafafa",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#d9d9d9",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "not-allowed"
    },
    queryMenuButtonItemDarkPush: {
        height: "36px",
        marginRight: "5px",
        padding: "8px 15px",
        borderRadius: "10px",
        backgroundColor: "#46494d",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    queryMenuButtonItemDarkPushHover: {
        height: "36px",
        marginRight: "5px",
        padding: "8px 15px",
        borderRadius: "10px",
        backgroundColor: "#333",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    queryMenuButtonItemDarkPushDisabled: {
        height: "36px",
        marginRight: "5px",
        padding: "8px 15px",
        borderRadius: "10px",
        backgroundColor: "#dcdfe6",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "not-allowed"
    },

    queryMenuControlFilterButton: {
        height: "20px",
        marginRight: "5px",
        padding: "8px 8px 8px 15px",
        borderRadius: "10px",
        border: "solid 1px #d4d9db",
        backgroundColor: "#fff",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#262626",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    queryMenuControlFilterButtonHover: {
        height: "20px",
        marginRight: "5px",
        padding: "8px 8px 8px 15px",
        borderRadius: "10px",
        border: "solid 1px #637aff",
        backgroundColor: "#fff",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#262626",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    queryMenuControlFilterButtonDisabled: {
        height: "20px",
        marginRight: "5px",
        padding: "8px 8px 8px 15px",
        borderRadius: "10px",
        border: "solid 1px #d4d9db",
        backgroundColor: "#fafafa",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#d9d9d9",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "not-allowed",
        
    },
    queryMenuControlFilterButtonExpandedImg: {
        width: "20px",
        height: "20px",
        marginLeft: "5px",
        filter: "none"
    },
    queryMenuControlFilterButtonItem: {
        height: "20px",
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 0px #d4d9db",
        backgroundColor: "#fff",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#262626",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    queryMenuControlFilterButtonItemHover: {
        height: "20px",
        
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 0px #d4d9db",
        backgroundColor: "#637aff",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    queryMenuControlFilterButtonItemDisabled: {
        height: "20px",
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 0px #637aff",
        backgroundColor: "#fafafa",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#d9d9d9",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "not-allowed"
    },
    queryMenuControlFilterButtonItemListContainer: {
        border: "solid 1px #d4d9db",
        borderRadius: "10px",
        marginRight: "5px"
    },
    queryMenuControlFilterButtonItemDivContainer: {
        width: "inherit",
        height: "1px",
        border: "0px",
        backgroundColor: "#d4d9db"
    },
    


    queryMenuControlPeriodButton: {
        height: "20px",
        marginRight: "5px",
        padding: "8px 8px 8px 15px",
        borderRadius: "10px",
        border: "solid 1px #d4d9db",
        backgroundColor: "#fff",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#262626",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    queryMenuControlPeriodButtonHover: {
        height: "20px",
        marginRight: "5px",
        padding: "8px 8px 8px 15px",
        borderRadius: "10px",
        border: "solid 1px #637aff",
        backgroundColor: "#fff",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#262626",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    queryMenuControlPeriodButtonDisabled: {
        height: "20px",
        marginRight: "5px",
        padding: "8px 8px 8px 15px",
        borderRadius: "10px",
        border: "solid 1px #d4d9db",
        backgroundColor: "#fafafa",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#d9d9d9",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "not-allowed",
        
    },
    queryMenuControlPeriodButtonExpandedImg: {
        width: "20px",
        height: "20px",
        marginLeft: "5px",
        filter: "none"
    },
    queryMenuControlPeriodButtonItem: {
        height: "20px",
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 0px #d4d9db",
        backgroundColor: "#fff",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#262626",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    queryMenuControlPeriodButtonItemHover: {
        height: "20px",
        
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 0px #d4d9db",
        backgroundColor: "#637aff",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    queryMenuControlPeriodButtonItemDisabled: {
        height: "20px",
        padding: "8px 15px",
        borderRadius: "10px",
        border: "solid 0px #637aff",
        backgroundColor: "#fafafa",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "0.83",
        color: "#d9d9d9",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "not-allowed"
    },
    queryMenuControlPeriodButtonItemListContainer: {
        border: "solid 1px #d4d9db",
        borderRadius: "10px",
        marginRight: "5px"
    },
    queryMenuControlPeriodButtonItemDivContainer: {
        width: "inherit",
        height: "1px",
        border: "0px",
        backgroundColor: "#d4d9db"
    },
};

export default QueryMenu;